<template>
  <v-main>
    <v-container class="col-10 pa-0 py-10 ma-0-auto page-wrapper">
      <v-btn to="/technologies" class="back-button green--text" text rounded>
        <v-icon class="mr-3" size="24px">mdi-arrow-left</v-icon>
        {{ $t('SideMenuTechnologies').children[0].name }}
      </v-btn>

      <!-- HEADER -->
      <div class="mt-10 mb-5">
        <h1 class="show-title">{{ technology.title }}</h1>
        <h3 class="show-description">{{ technology.subtitle }}</h3>
        <span class="show-date">
          {{ moment(technology.date).format('DD MMMM YYYY') }}
        </span>
      </div>

      <div>
        <div v-if="technology" class="d-flex flex-column flex-lg-row">
          <!-- IMAGE -->
          <v-col class="col-12 col-md-8 mx-auto col-lg-4 pa-0">
            <img :src="getImageURI(technology.image)" />
            <p class="darkgray--text photo-credit">
              {{ technology.imgSource }}
            </p>
          </v-col>

          <!-- MAIN -->
          <v-col class="col-12 col-lg-8 pa-0 pl-lg-12">
            <!-- CONTENT -->
            <div v-if="technology.page">
              <div
                class="tech-background"
                style="margin-top: -30px;"
                v-if="technology.page.background"
              >
                <h2 class="content-title">
                  {{ technology.page.background.title }}
                </h2>
                <div
                  class="content-body"
                  v-html="technology.page.background.content"
                ></div>
              </div>

              <div class="tech-overview" v-if="technology.page.overview">
                <h2 class="content-title">
                  {{ technology.page.overview.title }}
                </h2>
                <div
                  class="content-body"
                  v-html="technology.page.overview.content"
                ></div>
              </div>

              <div
                class="tech-further-details"
                v-if="technology.page.furtherDetails"
              >
                <h2 class="content-title">
                  {{ technology.page.furtherDetails.title }}
                </h2>
                <div
                  class="content-body"
                  v-html="technology.page.furtherDetails.content"
                ></div>
              </div>

              <div
                class="tech-stage-development"
                v-if="technology.page.stageDevelopment"
              >
                <h2 class="content-title">
                  {{ technology.page.stageDevelopment.title }}
                </h2>
                <div
                  class="content-body"
                  v-html="technology.page.stageDevelopment.content"
                ></div>
              </div>

              <div class="tech-benefits" v-if="technology.page.benefits">
                <h2 class="content-title">
                  {{ technology.page.benefits.title }}
                </h2>
                <div
                  class="content-body"
                  v-html="technology.page.benefits.content"
                ></div>
              </div>

              <div
                class="tech-applications"
                v-if="technology.page.applications"
              >
                <h2 class="content-title">
                  {{ technology.page.applications.title }}
                </h2>
                <div
                  class="content-body"
                  v-html="technology.page.applications.content"
                ></div>
              </div>

              <div class="tech-opportunity" v-if="technology.page.opportunity">
                <h2 class="content-title">
                  {{ technology.page.opportunity.title }}
                </h2>
                <div
                  class="content-body"
                  v-html="technology.page.opportunity.content"
                ></div>
              </div>

              <div class="tech-patents" v-if="technology.page.patents">
                <h2 class="content-title">
                  {{ technology.page.patents.title }}
                </h2>
                <div
                  class="content-body"
                  v-html="technology.page.patents.content"
                ></div>
              </div>

              <div class="tech-ip-status" v-if="technology.page.ipStatus">
                <h2 class="content-title">
                  {{ technology.page.ipStatus.title }}
                </h2>
                <div
                  class="content-body"
                  v-html="technology.page.ipStatus.content"
                ></div>
              </div>

              <div class="tech-seeking " v-if="technology.page.seeking">
                <h2 class="content-title">
                  {{ technology.page.seeking.title }}
                </h2>
                <div
                  class="content-body"
                  v-html="technology.page.seeking.content"
                ></div>
              </div>
            </div>
          </v-col>
        </div>
        <NotFound v-else menu="MenuTechnologies" />

        <v-col xs="12" sm="12" offset-md="2" md="8" class="mt-16">
          <ContactForm />
        </v-col>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import NotFound from './NotFound'
import ContactForm from '@/components/ContactForm'

export default {
  name: 'TechnologyPage',
  components: {
    NotFound,
    ContactForm,
  },
  data() {
    return {
      technologies: this.$t('technologies'),
      technology: {},
      slug: this.$route.params.slug,
    }
  },
  mounted() {
    this.technology = this.getTechnology()
  },
  updated() {
    this.checkImages()
  },

  methods: {
    getTechnology() {
      let tech = this.technologies.filter(tech =>
        tech.slug.includes(this.$route.params.slug)
      )

      return tech[0]
    },

    checkImages() {
      let imageWithCaption = document.querySelectorAll('.imageWithCaption img')
      imageWithCaption.forEach(elem => {
        let splittedElem = elem.src.split('/')
        let imageName = splittedElem[splittedElem.length - 1]
        let imageUri = this.getImageURI(imageName)
        elem.src = imageUri
      })
    },

    getImageURI(imageName) {
      if (imageName) {
        return require(`../assets/images/technologies/${imageName}`)
      }
      return 'https://cdn.vuetifyjs.com/images/cards/house.jpg'
    },
  },
}
</script>

<style lang="scss">
.back-button {
  font-family: $body-font-family;
  font-weight: normal;
  font-size: 16px;
  border: 1px solid #268c79;
  &.v-btn:before {
    background-color: rgba(#268c79, 0) !important;
  }
}

// .text-caption {
//   padding: 0 20%;
// }
</style>
